import { useQuery } from 'react-query';
import { getPatientData } from '../api/getPatientData';

const usePatientData = (page, rowsPerPage, order, orderBy, searchTerm, viewing, list) => {
  const result = useQuery(
    'patient_data_' +
      page +
      '_' +
      rowsPerPage +
      '_' +
      '_' +
      order +
      '_' +
      orderBy +
      '_' +
      searchTerm +
      '_' +
      list +
      '_' +
      viewing,
    () => getPatientData(page, rowsPerPage, order, orderBy, searchTerm, viewing, list),
    {
      refetchOnWindowFocus: false,
      staleTime: 50000,
    },
  );
  return result;
};

export default usePatientData;
